
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/infos",
      function () {
        return require("private-next-pages/infos.jsx");
      }
    ]);
  